import { CarvanaTheme } from '@carvana/showroom-theme';

const theme = {
  ...CarvanaTheme,
  carvana: {
    blue: {
      primary: '#00aed9',
      dark: '#185358',
    },
    gray: {
      light: '#d9dde9',
    },
    red: {
      primary: '#ff7171',
    },
    white: {
      primary: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Brandon Text", Lato, Helvetica, sans-serif',
  },
};

export default theme as typeof CarvanaTheme;
